<template><div><component-combinator component-name="DtPagination" /><h2 id="variants" tabindex="-1" class="d-docsite--header-2">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h2>
<h3 id="with-active-page" tabindex="-1" class="d-docsite--header-3">With Active Page <a class="header-anchor d-link d-docsite--link d-link" href="#with-active-page" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-pagination
  :total-pages=&quot;25&quot;
  :active-page=&quot;5&quot;
/&gt;'>
<dt-pagination
  :total-pages="25"
  :active-page="5"
/>
</code-example>
<h3 id="with-max-visible" tabindex="-1" class="d-docsite--header-3">With Max-Visible <a class="header-anchor d-link d-docsite--link d-link" href="#with-max-visible" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-pagination
  :total-pages=&quot;25&quot;
  :max-visible=&quot;7&quot;
/&gt;'>
<dt-pagination
  :total-pages="25"
  :max-visible="7"
/>
</code-example>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="pagination" /></div></template>


